/* scss/components/_gallery.scss */

;(function($, window, document) {

var masonrygrid = false;

    $(window).load(function() {

        if(typeof $.fn.masonry == 'function'){
            // reate a sizer element that define the size of masonary grid, @see:
            // https://github.com/desandro/masonry/tree/v4.1.0
            var sizer = $('<div class="grid-sizer"></div>');

            // select all gallery elements and append a sizer element
            masonrygrid = $('.ce_gallery.gallery-masonry ul').append(sizer);

            masonrygrid
            // setup the masonary effect to the element, @see: window.load at the end of the file
            .masonry({
                itemSelector: 'li',
                percentPosition: true,
                columnWidth: '.grid-sizer',
                horizontalOrder: true
            })
            // now find all images and setup a loader so that the images will stay in the right
            // position after loaded (width, height)
            .find('img').on('load', function(){
                masonrygrid.masonry();
            });


        }

        // window.sr = ScrollReveal({ reset: false });
        //
        // sr.reveal('.gallery-masonry ul li',
        //     {
        //         duration: 600,
        //         mobile: true,
        //         viewFactor: 0.4,
        //         origin: 'top',
        //     }
        // );


    });


})(jQuery, window, document);